import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40319201"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,ChefDetailCard: require('/vercel/path0/components/chef/detail-card.vue').default,ChefReview: require('/vercel/path0/components/chef/review.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
